module.exports = __webpack_public_path__ + "static/media/empty-set.b62216ac.svg";